import { User } from './user.model';
// Exporting all form-related options as empty arrays
export const PROFILE_DEFAULT_OPTIONS = {
  professionalRolesList: [
    'C-Suite / General Management',
    'Department Lead',
    'Team Leader',
    'Manager',
    'Associate / Junior',
    'Designer',
    'Project-Specific Role',
  ],
  projectRoles: ['Team Lead', 'Scrum Master', 'Project Manager', 'QA Lead'],
  businessTypes: ['Startup', 'SME', 'Corporate', 'Freelance'],
  creativeIndustrySectorsList: [
    'Film',
    'Music',
    'Art',
    'Fashion',
    'Architecture',
  ],
  marketDomainsList: [
    'Technology',
    'Finance',
    'Healthcare',
    'Education',
    'Retail',
  ],
  fieldOfExpertises: [
    'Special Skills',
    'Deep Knowledge',
    'Extended Experience',
  ],
  workStylePreferences: [
    'Solo',
    'Collaborative',
    'Contributing',
    'Assistance-Needing',
    'Focused',
    'Diffused',
    'Specialist',
    'Generalist',
    'Connector',
  ],
  digitalTools: ['Figma', 'Photoshop', 'Slack', 'Trello', 'JIRA'],
  preferredCommunicationMethods: [
    'Text',
    'Email',
    'Call',
    'In person',
    'Collab tool',
  ],
  preferredCommunicationStyles: [
    'Short',
    'Instructive',
    'Descriptive',
    'Objective',
    'Direct',
    'Empathic',
  ],
  teamPlays: [
    'Capacity and preference towards teamwork',
    'Support and cooperation',
  ],
  workTools: ['Laptop', 'Tablet', 'Smartphone', 'Workstation'],
  interestsAndInspirations: ['Personal', 'Professional'],
  favoriteArtistsArtworksCultures: [
    'Picasso',
    'Beethoven',
    'Leonardo da Vinci',
    'Van Gogh',
  ],
  leisureActivities: ['Hiking', 'Reading', 'Gaming', 'Yoga', 'Photography'],
  starSigns: [
    'Aries',
    'Taurus',
    'Gemini',
    'Cancer',
    'Leo',
    'Virgo',
    'Libra',
    'Scorpio',
    'Sagittarius',
    'Capricorn',
    'Aquarius',
    'Pisces',
  ],
  personalities: [
    'ISTJ - The Inspector',
    'ISFJ - The Protector',
    'INFJ - The Advocate',
    'INTJ - The Architect',
    'ISTP - The Crafter',
    'ISFP - The Artist',
    'INFP - The Mediator',
    'INTP - The Thinker',
    'ESTP - The Persuader',
    'ESFP - The Performer',
    'ENFP - The Champion',
    'ENTP - The Debater',
    'ESTJ - The Director',
    'ESFJ - The Caregiver',
    'ENFJ - The Protagonist',
    'ENTJ - The Commander',
  ],
  zodiacSigns: [
    'Rat',
    'Ox',
    'Tiger',
    'Rabbit',
    'Dragon',
    'Snake',
    'Horse',
    'Goat (Sheep)',
    'Monkey',
    'Rooster',
    'Dog',
    'Pig',
  ],
  ennagrams: [
    'Type 1: The Reformer',
    'Type 2: The Helper',
    'Type 3: The Achiever',
    'Type 4: The Individualist',
    'Type 5: The Investigator',
    'Type 6: The Loyalist',
    'Type 7: The Enthusiast',
    'Type 8: The Challenger',
    'Type 9: The Peacemaker',
  ],
};

// Exporting all form names as empty strings or null values
export const PROFILE_FORM_FIELD_NAMES = {
  firstName: '',
  lastName: '',
  email: '',
  initials: '',
  profilePhotoUrl: '',
  gender: '',
  dateOfBirth: '',
  professionalRoles: [],
  projectRole: [],
  businessType: '',
  creativeIndustrySectors: [],
  marketDomains: [],
  fieldOfExpertise: '', //missing
  workStyleAndPreference: '',
  digitalTools: '', // missing
  workTools: '',
  preferredCommunicationMethod: '',
  preferredCommunicationStyle: '',
  teamPlay: '',
  interestsAndInspirations: '',
  favoriteArtistsArtworkAndCultures: '',
  leisurelyActivities: '',
  website: '',
  instagram: '',
  linkedin: '',
  tiktok: '',
  youtube: '',
  imdb: '',
  vimeo: '',
  x: '',
  additionalSocialMediaChannels: [],
  starSign: '',
  zodiacSign: '',
  sixteenPersonalities: '',
  enneagram: '',
};

export type UserEdit = Omit<
  User,
  '_id' | 'accessToken' | 'lastLogin' | 'isAdmin'
> & {
  fullName?: string;
  username?: string;
};

export type UserEditSave = Omit<
  UserEdit,
  | '_id'
  | 'accessToken'
  | 'lastLogin'
  | 'isAdmin'
  | 'projectRole'
  | 'fullName'
  | 'initials'
  | 'email'
  | 'projectRoles'
  | 'creativeIndustrySector'
  | 'marketDomain'
  | 'permissions'
  | 'companies'
  | 'deletedAt'
  | 'password'
  | 'isVerified'
  | 'createdAt'
  | 'updatedAt'
  | '__v'
  | 'accessToken'
  | 'id'
  | 'collaborator'
>;
